import { useMemo } from 'react'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import OfferPageSignUpContent from 'components/Common/OfferPageSignUpContent'
import { useOfferPackagePrice } from 'hooks/Offers/useOfferPrice'
import FlashOfferSignUpDetails from './FlashOfferSignUpDetails'
import type { LastUsedLoginMethod } from 'lib/auth/lastUsedLoginMethod'

export interface FlashOfferSignUpContentProps {
  offer: App.HotelOffer
  pkg: App.HotelPackage
  packagePricing?: App.PricingWithValue
  packageMemberPricing?: App.PricingWithValue
  checkInDate?: string
}

interface Props extends FlashOfferSignUpContentProps {
  lastUsedLoginMethod?: LastUsedLoginMethod
  onAuthStep?: (mode: App.UiAccountModalMode, userId: string, appleData?: App.AppleLoginData) => void
}

/** The same offer-specific sign-up content appears in the modal and the page wall. */
function FlashOfferSignUpContent({ offer, pkg, packagePricing, packageMemberPricing, checkInDate, lastUsedLoginMethod, onAuthStep }: Props) {
  const pricing = useOfferPackagePrice(pkg, offer)
  const displayedDiscount = packagePricing ? packagePricing.discountPercent : pricing.valueOffPercent
  const displayedPrice = packagePricing ? packagePricing.price : pricing.totalPrice
  const displayedMemberPrice = packagePricing ? packageMemberPricing?.price : pricing.totalMemberPrice
  const saveUpToPercent = !offer.isDiscountPillHidden && displayedDiscount !== undefined && displayedDiscount >= MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE
    ? displayedDiscount
    : undefined
  const offerDetails = useMemo(() => <FlashOfferSignUpDetails
    offer={offer}
    pkg={pkg}
    price={displayedPrice}
    memberPrice={displayedMemberPrice}
    discountPercent={saveUpToPercent}
    checkInDate={checkInDate}
  />, [offer, pkg, displayedPrice, displayedMemberPrice, saveUpToPercent, checkInDate])

  return <OfferPageSignUpContent
    offerType="hotel"
    saveUpToPercent={saveUpToPercent}
    flashOfferDetails={offerDetails}
    lastUsedLoginMethod={lastUsedLoginMethod}
    onAuthStep={onAuthStep}
  />
}

export default FlashOfferSignUpContent
